import React from 'react';

export interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
}

const Card: React.FC<CardProps> = ({ children, className = '', title, subtitle }) => {
  return (
    <div className={` ${className}`}>
      {(title || subtitle) && (
        <div className="">
          {title && (
            <h3 className="text-base sm:text-lg font-medium text-gray-900">{title}</h3>
          )}
          {subtitle && (
            <p className="text-xs sm:text-sm text-gray-500 mt-1">{subtitle}</p>
          )}
        </div>
      )}
      <div className="">
        {children}
      </div>
    </div>
  );
};

export default Card;
